import axios from "axios";
import { retrieveData } from "../localconnection/LocalConnection.js";

let APL_LINK = "http://192.168.1.16:8000/";
// let Website_URL = "https://www.iapid.org/";
APL_LINK = "https://backendpython.thynkprocess.com.au/";
// APL_LINK = "http://127.0.0.1:7998/";
// APL_LINK = "https://q51gqszk-7998.inc1.devtunnels.ms/";
let version_vi_api_thynkprocess = APL_LINK + "api/v1/";

// API functions
const solution_page_save_update =
  version_vi_api_thynkprocess + "solution_page_save_update";
const get_solution_page_data =
  version_vi_api_thynkprocess + "get_solution_page_data";
const get_product_page_data =
  version_vi_api_thynkprocess + "get_product_page_data";
const product_page_save_update =
  version_vi_api_thynkprocess + "product_page_save_update";
const manage_page_active_status =
  version_vi_api_thynkprocess + "manage_page_active_status";
const get_lead_enquiry_data =
  version_vi_api_thynkprocess + "get_lead_enquiry_data";
const service_page_save_update =
  version_vi_api_thynkprocess + "service_page_save_update";
const get_service_page_data =
  version_vi_api_thynkprocess + "get_service_page_data";
const industry_page_save_update =
  version_vi_api_thynkprocess + "industry_page_save_update";
const get_industry_page_data =
  version_vi_api_thynkprocess + "get_industry_page_data";

const vacancy_save_update = version_vi_api_thynkprocess + "vacancy_save_update";

const get_vacancy_data = version_vi_api_thynkprocess + "get_vacancy_data";
const manage_vacancy_status =
  version_vi_api_thynkprocess + "manage_vacancy_status";
const delete_vacancy = version_vi_api_thynkprocess + "delete_vacancy";
const update_career_status =
  version_vi_api_thynkprocess + "update_career_status";
const media_uploads_view = version_vi_api_thynkprocess + "media_uploads_view";
const get_career_data = version_vi_api_thynkprocess + "get_career_data";
const blog_save_update = version_vi_api_thynkprocess + "blog_save_update";
const get_blog_data = version_vi_api_thynkprocess + "get_blog_data";
const delete_blog = version_vi_api_thynkprocess + "delete_blog";
const update_blog_status = version_vi_api_thynkprocess + "update_blog_status";
const get_staff_data = version_vi_api_thynkprocess + "get_staff_data";
const delete_staff = version_vi_api_thynkprocess + "delete_staff";
const manage_staff_status = version_vi_api_thynkprocess + "manage_staff_status";
const staff_save_update = version_vi_api_thynkprocess + "staff_save_update";
const webinar_page_config_save =
  version_vi_api_thynkprocess + "webinar_page_config_save";
const webinar_page_config_get =
  version_vi_api_thynkprocess + "webinar_page_config_get";
const webinar_event_save_update =
  version_vi_api_thynkprocess + "webinar_event_save_update";
const get_webinar_event_data =
  version_vi_api_thynkprocess + "get_webinar_event_data";
const manage_webinar_status =
  version_vi_api_thynkprocess + "manage_webinar_status";
const delete_webinar_event =
  version_vi_api_thynkprocess + "delete_webinar_event";
const get_dashboard_statistics =
  version_vi_api_thynkprocess + "get_dashboard_statistics";
const get_designation_data =
  version_vi_api_thynkprocess + "get_designation_data";

const case_study_save_update =
  version_vi_api_thynkprocess + "case_study_save_update";
const get_case_study_data = version_vi_api_thynkprocess + "get_case_study_data";
const manage_case_study_status =
  version_vi_api_thynkprocess + "manage_case_study_status";
const delete_case_study = version_vi_api_thynkprocess + "delete_case_study";
const login_to_admin = version_vi_api_thynkprocess + "login_to_admin";
const dynamic_page_save_update =
  version_vi_api_thynkprocess + "dynamic_page_save_update";
const get_media_library = version_vi_api_thynkprocess + "get_media_library";
const get_dynamic_page_detail =
  version_vi_api_thynkprocess + "get_dynamic_page_detail";
const get_admin_profile = version_vi_api_thynkprocess + "get_admin_profile";
const update_admin_profile =
  version_vi_api_thynkprocess + "update_admin_profile";
const change_admin_password =
  version_vi_api_thynkprocess + "change_admin_password";
const licensing_config_save =
  version_vi_api_thynkprocess + "licensing_config_save";
const licensing_config_get =
  version_vi_api_thynkprocess + "licensing_config_get";
const estimator_config_save =
  version_vi_api_thynkprocess + "estimator_config_save";
const estimator_config_get =
  version_vi_api_thynkprocess + "estimator_config_get";
const manage_page_delete = version_vi_api_thynkprocess + "manage_page_delete";
const get_newsletter_subscribers =
  version_vi_api_thynkprocess + "get_newsletter_subscribers";
const manage_subscriber_status =
  version_vi_api_thynkprocess + "manage_subscriber_status";
const delete_subscriber = version_vi_api_thynkprocess + "delete_subscriber";
const get_campaign_data = version_vi_api_thynkprocess + "get_campaign_data";
const campaign_save_update =
  version_vi_api_thynkprocess + "campaign_save_update";
const send_campaign = version_vi_api_thynkprocess + "send_campaign";
const delete_campaign = version_vi_api_thynkprocess + "delete_campaign";

const logoutAndClearData = () => {
  // Clear all stored data
  localStorage.clear();
  sessionStorage.clear();

  // Optional: redirect to login page
  window.location.href = "/"; // apna login route yahan daalein
};
const server_post_data = async (url_for, payload) => {
  try {
    const retrievedAdminId = retrieveData("admin_super_id");
    let packageName = "Default";

    // अगर FormData है
    if (payload instanceof FormData) {
      payload.append("admin_id", retrievedAdminId);

      return await axios.post(url_for, payload, {
        headers: {
          "X-Package-Name": packageName,
          "Content-Type": "multipart/form-data",
        },
      });
    }

    // अगर normal JSON है
    const jsonPayload = {
      ...payload,
      admin_id: retrievedAdminId,
    };

    return await axios.post(url_for, jsonPayload, {
      headers: {
        "X-Package-Name": packageName,
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    if (error.response && error.response.status === 401) {
      logoutAndClearData();
    }
    throw error;
  }
};

export {
  APL_LINK,
  // Website_URL,
  version_vi_api_thynkprocess,
  server_post_data,
  solution_page_save_update,
  get_solution_page_data,
  get_product_page_data,
  product_page_save_update,
  manage_page_active_status,
  get_lead_enquiry_data,
  service_page_save_update,
  get_service_page_data,
  industry_page_save_update,
  get_industry_page_data,
  vacancy_save_update,
  get_vacancy_data,
  manage_vacancy_status,
  delete_vacancy,
  get_career_data,
  update_career_status,
  media_uploads_view,
  blog_save_update,
  get_blog_data,
  delete_blog,
  case_study_save_update,
  get_case_study_data,
  manage_case_study_status,
  delete_case_study,
  login_to_admin,
  dynamic_page_save_update,
  get_media_library,
  get_dynamic_page_detail,
  get_admin_profile,
  update_admin_profile,
  change_admin_password,
  get_staff_data,
  delete_staff,
  manage_staff_status,
  staff_save_update,
  get_designation_data,
  webinar_page_config_save,
  webinar_page_config_get,
  webinar_event_save_update,
  get_webinar_event_data,
  manage_webinar_status,
  delete_webinar_event,
  licensing_config_save,
  licensing_config_get,
  get_dashboard_statistics,
  estimator_config_save,
  estimator_config_get,
  manage_page_delete,
  get_newsletter_subscribers,
  manage_subscriber_status,
  delete_subscriber,
  get_campaign_data,
  campaign_save_update,
  send_campaign,
  delete_campaign,
  update_blog_status,
};
